import React from 'react';
import { faqs } from '../data/mockData';
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from './ui/accordion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const FAQSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });
  const content = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-14 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="text-xs font-bold uppercase tracking-widest text-[#FF1010] block mb-3">FAQ</span>
          <h2 className="text-3xl sm:text-4xl font-black tracking-tighter text-[#111827] mb-4 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Got Questions? Good.
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            Here are the answers to the questions we hear most about trademark registration.
          </p>
        </div>

        <div ref={content.ref} className={`max-w-3xl mx-auto scroll-fade-up scroll-delay-2 ${content.isVisible ? 'scroll-visible' : ''}`}>
          <Accordion type="single" collapsible>
            {faqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} data-testid={`faq-item-${faq.id}`} className="border-b border-[#E5E7EB]">
                <AccordionTrigger className="text-left text-sm font-bold text-[#111827] hover:text-[#FF1010] py-5 [&[data-state=open]]:text-[#FF1010]">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[#4B5563] leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
